module.exports = __webpack_public_path__ + "img/m_icon1.06d1539e.png";